import React, { useEffect, useRef } from 'react';
import { Layout, Modal, Close } from './styled';
import loginmask from 'assets/img/loginmask.jpg';
import useResponsive from 'utils/hooks/useResponsive';
import useModal from 'utils/hooks/useModal';
import Left from './Left';
import Right from './Right';

const Index = () => {
  const { showModal, handleCloseModal } = useModal();
  const { isTab } = useResponsive();
  const img = useRef()

  useEffect(() => {
    const preloadImg = new Image()
    preloadImg.src = loginmask
    img.current = preloadImg
  }, [])

  useEffect(() => {
    if (showModal) document.body.style.overflow = 'hidden'
    else document.body.style.overflow = 'visible'
    return () => document.body.style.overflow = 'visible'
  }, [showModal])

  return (
    <>
      {showModal && (
        <Layout>
          <Modal bgImg={img.current?.src} isTab={isTab}>
            <Close onClick={handleCloseModal}/>
            <Left/>
            <Right/>
          </Modal>
        </Layout>
      )}
    </>
  )
}

export default Index
